var Utils = require("common/Utils");
var postal = require("common/PubSub");

module.exports = function($listview) {
    var self = this;
    var electronChannel = postal.channel("Electron");

    electronChannel.subscribe("transfers-progress-update", function(data) {
        var listItem = $listview.find('[data-transfer-id="' + data.transferId + '"]');

        if (listItem.length == 0) {
            self.addEntry(data);

            if ($listview.hasClass("ui-listview")) {
                $listview.listview("refresh");
            }
        }

        updateEntry(listItem, data);
    });

    this.setTransfers = function(transfers) {
        $listview.empty();

        transfers.sort(function(a, b) {
            return (a.startTime && b.startTime)
                ? a.startTime - b.startTime
                : 0;
        });

        transfers.forEach(function(transfer) {
            self.addEntry(transfer);
        });

        if ($listview.hasClass("ui-listview")) {
            $listview.listview("refresh");
        }
    };

    this.addEntry = function(data) {
        var dotIndex = data.filename.lastIndexOf(".");
        var fileSuffix = (dotIndex === -1) ? "file" : data.filename.substr(dotIndex + 1).toLowerCase();
        var listItem = $("<li>", {
            "data-transfer-id" : data.transferId,
            "data-filetype" : fileSuffix,
            "data-type" : data.transferType
        });
        var $innerDiv = $("<div>");
        $innerDiv.append($("<span>", {"class" : "filenameLabel", text : data.filename, title : data.filename}));
        $innerDiv.append($("<span>", {"class" : "progress"}));

        var $cancelButton = $("<a>", {"class" : "cancel"});
        $cancelButton.on("click", function() {
            if (listItem.attr("data-status") === "transferring") {
                electronChannel.publish("cancel-transfer", data);
            } else {
                // Remove from transfer manager
                electronChannel.publish("remove-inactive-file-transfer", data);
                listItem.remove();
            }
        });

        var $rightSpan = $("<span>");

        // We can't retry uploads so only create a retry button for downloads
        if (data.transferType === "download") {
            var $retryButton = $("<a>", {"class" : "retry"});
            $retryButton.on("click", function() {
                var retryData = $.extend({uri : data.transferId}, data);
                electronChannel.publish("start-file-download", retryData);
            });

            $rightSpan.append($retryButton);

            // Also, only try and open files if they are downloads
            listItem.on("click", function() {
                if (listItem.attr("data-status") === "completed") {
                    electronChannel.publish("open-downloaded-file", data);
                }
            });
        }

        $rightSpan.append($cancelButton);
        listItem.append($("<div>").append($innerDiv).append($rightSpan));
        $listview.prepend(listItem);

        updateEntry(listItem, data);
    };

    this.clear = function() {
        $listview.find("li").each(function(index, element) {
            var listItem = $(element);

            if (listItem.attr("data-status") != "transferring") {
                listItem.remove();

                // Remove from transfer manager
                electronChannel.publish("remove-inactive-file-transfer", {transferId : listItem.attr("data-transfer-id")});
            }
        });
    };

    function updateEntry(listItem, data) {
        listItem.attr("data-status", data.status);

        var progressMessage;

        var statusMessageKeys = {
            completed : $.t("common::vfs.fileTransfers.complete"),
            cancelled : $.t("common::vfs.fileTransfers.cancelled"),
            failed : $.t("common::vfs.fileTransfers.failed"),
            pending : $.t("common::vfs.fileTransfers.pending"),
            missing : $.t("common::vfs.fileTransfers.missing")
        };

        if (data.status == "transferring") {
            var transferredString = Utils.formatBytesAsString(data.transferred);

            if (data.progress) {
                progressMessage = $.t("common::vfs.fileTransfers.progress", {transferred : transferredString, percentage : data.progress});
            } else {
                progressMessage = transferredString;
            }
        } else {
            progressMessage = statusMessageKeys[data.status];
        }

        listItem.find(".progress").html(progressMessage);
    }
};